module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e3077ea26cf0fc3393020f2cc3f87119.png";